/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { TInspectorNode } from "../InspectorNodeTypes";
import { ISchemaBuilderDateModel, isSchemaBuilderDateModel } from "@adapptio/lib-blueprint";
import { mapModelToNodes } from "../index";

export function builderDateMapper(model: ISchemaBuilderDateModel): TInspectorNode {
	if (!isSchemaBuilderDateModel(model)) {
		return;
	}

	return mapModelToNodes(model.props);
}
